// extracted by mini-css-extract-plugin
export var navBar = "navbar-module--nav-bar--38TwR";
export var navLogoItem = "navbar-module--nav-logo-item--eQWkK";
export var navLogo = "navbar-module--nav-logo--32HQp";
export var navLinks = "navbar-module--nav-links--dne_I";
export var navLinkItem = "navbar-module--nav-link-item--3EImQ";
export var navLinkText = "navbar-module--nav-link-text--6iRz-";